export default {
    labels: {
        title: 'Document Analysis: ',
        subtitle: 'Discrepancies were found. Please check the fields to review below.',
        valueNotFound: 'Not found',
        confidencePercentage: 'Confidence',
        denialRisk: 'Risk of rejection: ',
        howToFix: 'How to fix: '
    },
    grid: {
        columns: {
            field: 'Field',
            valueReadedByAi: 'What was read in the document',
            reason: 'Rejection reasons',
            status: 'Status'
        }
    },
    actions: {
        replaceDocument: 'Replace Document',
        cancel: 'Cancel'
    },
    errorReasons: {
        requiredFieldNotProvided: {
            reason: 'This field in the document is mandatory and has not been filled out',
            howToFix: 'Fill it out following the standards required for this type of document'
        },
        incorrectValue: {
            reason: 'This field does not comply with ANS standards.',
            howToFix: 'Fill it out following the standards required for this type of document.'
        },
        conflictValues: [
            {
                subreasonKey: 'Value Differs from Osigu Input',
                reason: 'This field in the document differs from the information recorded in the system',
                howToFix: 'Check the field {field} in your system'
            },
            {
                subreasonKey: 'Inconsistency detected in doctor´s name',
                reason: 'This field was filled out as {value}, but this name does not match the professional associated with the provided CRM.',
                howToFix: 'Correct this field and update it with the full name as registered in the council.'
            },
            {
                subreasonKey: 'Doctor has an inactive CRM status',
                reason: 'This field was filled out with the number {value}, but this CRM is inactive in the professional council.',
                howToFix: 'Replace it with the record of an active professional and also update the corresponding name in field 15.'
            },
            {
                subreasonKey: 'Invalid Procedure Code',
                reason: 'This field was filled out with the code {value}, but it is inactive in the current TUSS table',
                howToFix: 'Check the latest version of the TUSS table provided by ANS and replace it with an active code that matches the requested procedure.'
            },
            {
                subreasonKey: 'Procedure code does not match procedure',
                reason: 'This field was filled out with the code {value}, but it does not match the procedure description provided in the document.',
                howToFix: 'Replace it with the TUSS code corresponding to the correct description.'
            }
        ],
        documentNotMatched: {
            reason: 'The uploaded file does not appear to be a valid TISS Guide.',
            howToFix: 'Check if the attached document corresponds to a TISS Guide'
        }
    }
}